import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { Toast } from '../models/toast';
import { ToastBuilder } from '../builders/toast.builder';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly builder = inject(ToastBuilder);

  private readonly showSource$ = new ReplaySubject<Toast>(1);

  public get show$(): Observable<Toast> {
    return this.showSource$.asObservable();
  }

  public show(factory: (builder: ToastBuilder) => Toast): void {
    this.showSource$.next(factory(this.builder));
  }
}
